import { Box } from '@mantine/core';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { useLoadDebtorBalance } from 'shared/hooks/use-load-debtor-balance';
import { BalanceSummaryPanel } from './BalanceSummaryPanel';
import { BalanceTableDetail } from './BalanceTable/BalanceTableDetail';

export const BalanceTab = () => {
  const debtor = useDebtor();
  const company = useCompanyConfiguration();

  const { debtorBalance, isDebtorBalanceLoading, isDebtorBalanceFetching } = useLoadDebtorBalance(
    String(debtor.id),
    true,
  );

  return (
    <Box>
      <BalanceSummaryPanel
        debtorBalance={debtorBalance}
        currency={company.currency}
        isLoading={isDebtorBalanceLoading || isDebtorBalanceFetching}
      />
      <BalanceTableDetail
        debtorBalance={debtorBalance}
        isLoading={isDebtorBalanceLoading || isDebtorBalanceFetching}
      />
    </Box>
  );
};
